export default {
    ca: {
        title: 'Duplicar el mapa',
        message: 'Segur que vols duplicar el mapa a la teva galeria?',
        esborrar: 'Duplicar',
        messageError: 'No s\'ha pogut duplicar el mapa',
        duplicar: 'Duplicar mapa',
        newMapNom: 'Nom del nou mapa duplicat',
        formValidation: 'El camp no pot estar buit',
        messageDuplicate: 'El procés de duplicar un mapa pot trigar minuts. Quan hagi acabat el procés trobareu el mapa duplicat a la vostra galeria.',
        messageNoLogat: 'Has d\'iniciar sessió per poder duplicar un mapa de la galeria pública',
    },
    es: {
        title: 'Duplicar el mapa',
        message: '¿Seguro que quieres duplicar el mapa en tu galería?',
        esborrar: 'Duplicar',
        messageError: 'No se ha podido duplicar el mapa',
        duplicar: 'Duplicar mapa',
        newMapNom: 'Nombre del nuevo mapa duplicado',
        formValidation: 'El campo no puede estar vacío',
        messageDuplicate: 'El proceso de duplicar un mapa puede tardar unos minutos. Cuando haya acabado el proceso encontrareis el mapa duplicado en vuestra galeria.',
        messageNoLogat: 'Tienes que iniciar sesión para poder duplicar un mapa de la galería pública',
    },
    en: {
        title: 'Duplicate the map',
        message: 'Are you sure you want to duplicate the map in your gallery?',
        esborrar: 'Duplicate',
        messageError: 'Could not duplicate the map',
        duplicar: 'Duplicate map',
        newMapNom: 'Name of the new duplicated map',
        formValidation: 'The field can\'t be left empty',
        messageDuplicate: 'The process of duplicating a map may take minutes. When the process is finished you will find the duplicated map in your gallery.',
        messageNoLogat: 'You have to login in to clone a map from the public gallery',
    },
};



// WEBPACK FOOTER //
// ./src/gallery/components/clonar-modal/clonar-modal-translations.js